import React from "react";
import { Bannerdata,BlogData} from "../../../../data/blogs/data";
import BannerNews from "../../../../components/body/topnewsupdates/newsupdates/BannerNews";
import Navbar from "../../../../components/Navbar/Navbar";
import Main_Footer from "../../../../components/footer/IndiaFooter/Main_Footer";
import Heading2 from "../../../../components/body/topnewsupdates/newsupdates/Heading2";
import Slider_card from "../../../../components/body/topnewsupdates/Slider-Card";

const Blog = () => {

  return (
    <div>
      <Navbar />
      <BannerNews Bannerdata={Bannerdata} />
      <Heading2 BlogData={BlogData[180425]} />

      {/* <Slider_card sliderData={sliderData} /> */}
      <Main_Footer />
    </div>
  );
};

export default Blog;
